module.exports = __webpack_public_path__ + "img/icon-warning-ice-red.236632c6.svg";